if (!customElements.get('rfn-purchase-guard')) {
  customElements.define('rfn-purchase-guard', class extends HTMLElement {
    constructor() {
      super();
      this.validatePurchase = this.validatePurchase.bind(this);
    }
    connectedCallback() {
      this.addEventListener('submit', this.validatePurchase, true);
      this.addEventListener('click', this.validatePurchase, true);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.validatePurchase, true);
      this.removeEventListener('click', this.validatePurchase, true);
    }
    validatePurchase(event) {
      if (event.type === 'click' && !event.target.closest('.product-form__shop-pay')) return;
      const quantity = this.closest('product-info')?.querySelector('input[name="quantity"]');
      if (!quantity || quantity.checkValidity()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      quantity.reportValidity();
    }
  });
}
